export default "__VITE_ASSET__B4J3dMF4__"